 export const ENV = 'v1' // prod
 export const ENV_AUTH = 'mobile_client'; // prod

 // export const ENV = 'test' // test
 // export const ENV_AUTH = 'mobile_client_test' // test

export const gtm_code = 'GTM-5M6MBW2'; 